// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'
import message from './messages'

const state = {
  projectListApplication: [],
  projectContractorList: [],
  contractorList: [],
  contractorDocuments: [],
  contractorProjectDocuments: [],
  contractorProjectSelected: {},
  //projectBudgetList: [],
  projectOnGoingList: [],
  projectCompletedList: [],
  allProjectList: [],
  projectOwnerList: [],
  //affectedAssetList: [],
  //needList: [],
  projectMilestoneList: [],
  //affectedAssetList: []
  projectFundingSourceList: [],
  projectSelected: {},
  projectSelectedPlanPicture: [],
  projectSelectedApplicationPicture: [],
  projectSelectedReportingPicture: [],
  projectSelectedCompletionPicture: []
}

const mutations = {
  setProjectListApplication(state, payload) {
    state.projectListApplication = payload;
  },
  setProjectContractorList(state, payload) {
    state.projectContractorList = payload;
  },
  setContractorProjectSelected(state, payload) {
    state.contractorProjectSelected = payload;
  },
  setContractorList(state, payload) {
    state.contractorList = payload;
  },
  setContractorDocuments(state, payload) {
    state.contractorDocuments = payload;
  },
  setContractorProjectDocuments(state, payload) {
    state.contractorProjectDocuments = payload;
  },
  /*setProjectBudgetList(state, payload) {
    state.projectBudgetList = payload;
  },*/
  setProjectOnGoingList(state, payload) {
    state.projectOnGoingList = payload;
  },
  setProjectCompletedList(state, payload) {
    state.projectCompletedList = payload;
  },
  setAllProjectList(state, payload) {
    state.allProjectList = payload;
  },
  setProjectOwnerList(state, payload) {
   state.projectOwnerList = payload;
  },
  /*setAffectedAssetList(state, payload) {
   state.affectedAssetList = payload;
  },
  setNeedList(state, payload) {
   state.needList = payload;
  },*/
  setProjectMilestoneList(state, payload) {
   state.projectMilestoneList = payload;
  },
  /*setAffectedAssetList(state, payload) {
   state.affectedAssetList = payload;
  },*/
  setProjectFundingSourceList(state, payload) {
   state.projectFundingSourceList = payload;
  },
  setProjectSelected(state, payload) {
   state.projectSelected = payload;
  },
  setProjectSelectedPlanPicture(state, payload) {
   state.projectSelectedPlanPicture = payload;
  },
  setProjectSelectedApplicationPicture(state, payload) {
   state.projectSelectedApplicationPicture = payload;
  },
  setProjectSelectedReportingPicture(state, payload) {
   state.projectSelectedReportingPicture = payload;
  },
  setProjectSelectedCompletionPicture(state, payload) {
   state.projectSelectedCompletionPicture = payload;
  }
}

const actions = {
  getProjectDetails: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/project_details`,payload).then(response => {
        //console.log('***response.data', response.data);
        commit('setProjectSelected', response.data);
      });
    } catch(error){
      commit('setProjectSelected', []);
    }
  },
  getProjectPlanPicture: ({ state, commit, dispatch }, payload) => {

    state.projectSelectedPlanPicture = [];

    try{

      for(var i=0; i < payload.length; i++){

        axios.post(`/api/project_need_single_picture`,payload[i]).then(response => {
            state.projectSelectedPlanPicture.push(response.data);
          });

      }

    } catch(error){
      commit('setProjectSelectedPlanPicture', []);
    }
  },
  getProjectApplicationPicture: ({ state, commit, dispatch }, payload) => {

    state.projectSelectedApplicationPicture = [];

    try{

      /*axios.post(`/api/project_application_picture`,payload).then(response => {
        commit('setProjectSelectedApplicationPicture', response.data);
      });*/

      for(var i=0; i < payload.length; i++){

        axios.post(`/api/project_application_single_picture`,payload[i]).then(response => {
            state.projectSelectedApplicationPicture.push(response.data);
            //console.log('STORE state.projectSelectedApplicationPicture', state.projectSelectedApplicationPicture);
          });

      }

    } catch(error){
      commit('setProjectSelectedApplicationPicture', []);
    }
  },
  getProjectReportingPicture: ({ state, commit, dispatch }, payload) => {
    
    state.projectSelectedReportingPicture = [];

    try{
      
      /*axios.post(`/api/project_reporting_picture`,payload).then(response => {
        commit('setProjectSelectedReportingPicture', response.data);
      });*/

      for(var i=0; i < payload.length; i++){

        axios.post(`/api/project_reporting_single_picture`,payload[i]).then(response => {
            state.projectSelectedReportingPicture.push(response.data);
            //console.log('STORE state.projectSelectedApplicationPicture', state.projectSelectedReportingPicture);
          });

      }

    } catch(error){
      commit('setProjectSelectedReportingPicture', []);
    }
  },
  getProjectCompletionPicture: ({ state, commit, dispatch }, payload) => {
    
    state.projectSelectedCompletionPicture = [];

    try{
      
      /*axios.post(`/api/project_completion_picture`,payload).then(response => {
        commit('setProjectSelectedCompletionPicture', response.data);
      });*/

      for(var i=0; i < payload.length; i++){

        axios.post(`/api/project_completion_single_picture`,payload[i]).then(response => {
            state.projectSelectedCompletionPicture.push(response.data);
            //console.log('STORE state.projectSelectedApplicationPicture', state.projectSelectedCompletionPicture);
          });

      }


    } catch(error){
      commit('setProjectSelectedCompletionPicture', []);
    }
  },
  getProjectListApplication: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
      axios.post(`/api/project_application_list`, user_parameter).then(response => {
        commit('setProjectListApplication', response.data);
      });
    } catch(error){
      commit('setProjectListApplication', []);
    }
  },
  getProjectContractorList: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
      axios.post(`/api/project_contractor_list`, user_parameter).then(response => {

        commit('setProjectContractorList', response.data);
      });
    } catch(error){
      commit('setProjectContractorList', []);
    }
  },
  getContractorList: ({ state, commit }) => {
    try{
      axios.get(`/api/contractor_list`).then(response => {

        if(auth.state.user.user_profile_id !== 1){
            
            var contractor_list_of_user = response.data.filter(contractor => contractor.province_id === auth.state.user.province_id);
            commit('setContractorList', contractor_list_of_user);

          }else{
            commit('setContractorList', response.data);
          }

        //commit('setContractorList', response.data);
      });
    } catch(error){
      commit('setContractorList', []);
    }
  },
  getContractorProjectSelected: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/project_contractor_details`,payload).then(response => {
        commit('setContractorProjectSelected', response.data);
      });
    } catch(error){
      commit('setContractorProjectSelected', []);
    }
  },
  getContractorDocuments: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/contractor_documents`, payload).then(response => {
        commit('setContractorDocuments', response.data);
      });
    } catch(error){
      commit('setContractorDocuments', []);
    }
  },
  getContractorProjectDocuments: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/contractor_project_documents`, payload).then(response => {
        commit('setContractorProjectDocuments', response.data);
      });
    } catch(error){
      commit('setContractorProjectDocuments', []);
    }
  },
  /*getProjectBudgetList: ({ state, commit }) => {
    try{
      axios.get(`/api/project_budget_list`).then(response => {

        commit('setProjectBudgetList', response.data);
      });
    } catch(error){
      commit('setProjectBudgetList', []);
    }
  },*/
  getProjectOnGoingList: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
      axios.post(`/api/project_on_going_list`, user_parameter).then(response => {
        commit('setProjectOnGoingList', response.data);
      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  },
  getProjectCompletedList: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
      axios.post(`/api/project_completed_list`, user_parameter).then(response => {

        commit('setProjectCompletedList', response.data);
      });
    } catch(error){
      commit('setProjectCompletedList', []);
    }
  },
  getAllProjectList: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
      axios.post(`/api/all_project_list`, user_parameter).then(response => {

        commit('setAllProjectList', response.data);
      });
    } catch(error){
      commit('setAllProjectList', []);
    }
  },
  addProject: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      //console.log('****payload', payload);

      //axios.post(`/api/new_project`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
      axios.post(`/api/new_project`,payload).then(response => {

        message.mutations.setConfirmationAdd(message.state, true);
        payload.project_id = response.data.id;

        if(payload.project_baseline_pictures && payload.project_baseline_pictures.length !== 0){

          dispatch('addNewProjectPictures',payload);

        }

        dispatch('addNewProjectDocuments',payload);


        dispatch('getProjectListApplication');
      });
    } catch(error){

      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectListApplication', []);
    }
  },
  addNewProjectPictures: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/new_project_pictures`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        dispatch('getProjectListApplication');
      });
    } catch(error){

      console.log('error', error);

      commit('setProjectListApplication', []);
    }
  },
  addNewProjectDocuments: ({ state, commit, dispatch }, payload) => {
    try{
      
      axios.post(`/api/new_project_documents`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        dispatch('getProjectListApplication');
      });
    } catch(error){

      console.log('error', error);

      commit('setProjectListApplication', []);
    }
  },
  updateProjectPlanningInformation: ({ state, commit, dispatch }, payload) => {
    try{
      
      payload.username = auth.state.username;

      axios.post(`/api/update_project_planning_information`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        
        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectListApplication');
        dispatch('getProjectContractorList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectListApplication', []);
    }
  },
  updateProjectStatus: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_status`,payload).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectListApplication');
        //dispatch('getProjectCompletedList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectListApplication', []);
    }
  },
  createContractorDocument: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/create_contractor_documents`,payload).then(response => {
        dispatch('getProjectListApplication');
      });
    } catch(error){
      commit('setProjectListApplication', []);
    }
  },
  updateContractorDocument: ({ state, commit, dispatch }, payload) => {
    try{
      
      payload.username = auth.state.username;

      axios.post(`/api/update_contractor_documents`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectContractorList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectContractorList', []);
    }
  },
  /*updateLastReporting: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/update_last_reporting`,payload).then(response => {
        dispatch('getProjectCompletedList');
      });
    } catch(error){
      commit('setProjectListApplication', []);
    }
  },*/
  updateBudget: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;
      
      axios.post(`/api/update_project_budget`,payload).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectContractorList');
        //dispatch('getProjectOnGoingList');

      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectContractorList', []);
    }
  },
  addNewFund: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/add_new_project_other_fund`,payload).then(response => {
        //dispatch('getProjectCompletedList');
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  },
  updateExpense: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_budget_expense`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        //dispatch('getProjectCompletedList');
        
        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('checkIfProjectCompleted',{id: payload.project_id});
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  updateProjectMilestoneStatus: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_milestone`,payload).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  updateProjectReportingStatus: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_reporting`,payload).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  updateProjectReportingDocument: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_reporting_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  updateProjectCompletionDocument: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_completion_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        //dispatch('getProjectCompletedList');
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('setProjectCompletedList', []);
    }
  },
  updateVFMCompletion: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_vfm_completion`,payload).then(response => {

        //dispatch('getProjectCompletedList');
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('setProjectCompletedList', []);
    }
  },
  updateProjectComments: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_project_comments`,payload).then(response => {

        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  },
  getProjectOwnerList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_owners`).then(response => {

          if(auth.state.user.user_profile_id === 3){

            var project_list_of_user = response.data.filter(po => po.id === auth.state.user.project_owner_id);
            commit('setProjectOwnerList', project_list_of_user);

          }else{
            commit('setProjectOwnerList', response.data);
          }

        //commit('setProjectOwnerList', response.data);
      });
    } catch(error){
      commit('setProjectOwnerList', []);
    }
  },
  /*getAffectedAssetList: ({ state, commit }, payload) => {
    try{
        axios.post(`/api/affected_assets_disaster`,payload).then(response => {

        console.log('response',response);
        //TO PUT ON SERVER SIDE AND COMPLETE WITH OTHER ASSET
        var affectedAssets = [];
        for(var i=0; i< response.data.length; i++){
          if(response.data[i].affected_road){
            var obj = {
              id: response.data[i].id,
              asset_number: response.data[i].affected_road.road_referential.asset_number,
              name: response.data[i].affected_road.road_referential.name_la,
              asset_type: response.data[i].asset_type.translation.name
            }
            affectedAssets.push(obj);
          }
        }

        commit('setAffectedAssetList', affectedAssets);
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },*/
  /*getNeedList: ({ state, commit }) => {
    try{
        axios.get(`/api/need_list`).then(response => {
        commit('setNeedList', response.data);
      });
    } catch(error){
      commit('setNeedList', []);
    }
  },*/
  getProjectMilestoneList: ({ state, commit }, payload) => {
    try{
        axios.post(`/api/project_milestone`,payload).then(response => {
        commit('setProjectMilestoneList', response.data);
      });
    } catch(error){
      commit('setProjectMilestoneList', []);
    }
  },
  addExpense: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_expense`,payload).then(response => {

        message.mutations.setConfirmationAdd(message.state, true);

        dispatch('checkIfProjectCompleted',{id: payload.project_id});

        dispatch('getProjectOnGoingList');
        //dispatch('getProjectCompletedList');

      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  checkIfProjectCompleted: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/check_completed_project`,payload).then(response => {

        //console.log('response', response);
        dispatch('getProjectOnGoingList');
        //dispatch('getProjectCompletedList');

      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  },
  addExpenseDocument: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_expense_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  },
  /*addDocument: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/new_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      commit('getProjectOnGoingList', []);
    }
  },*/
  /*downloadExpenseDocument: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/download_expense_document`,payload).then(response => {

        //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
        if(response.data.file){
          var bytes = new Uint8Array(response.data.file.data); // pass your byte response to this constructor
          var blob_type = response.data.mimetype;
          var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download=response.data.original_name;
          link.click();
        }

      });
    } catch(error){
      commit('getProjectOnGoingList', []);
    }
  },*/
  downloadImg: ({ state, commit, dispatch }, payload) => {

    //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
    if(payload.file){
      var bytes = new Uint8Array(payload.file.data); // pass your byte response to this constructor
      var blob_type = payload.mimetype;
      var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

      var link=document.createElement('a');
      link.href=window.URL.createObjectURL(blob);
      link.download=payload.original_name;
      link.click();
    }

  },
  downloadDocument: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/download_document`,payload).then(response => {

        //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
        if(response.data.file){
          var bytes = new Uint8Array(response.data.file.data); // pass your byte response to this constructor
          var blob_type = response.data.mimetype;
          var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download=response.data.original_name;
          link.click();
        }

      });
    } catch(error){
      commit('getProjectOnGoingList', []);
    }
  },
  downloadContractorDocument: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/download_contractor_document`,payload).then(response => {

        //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
        if(response.data.file){
          var bytes = new Uint8Array(response.data.file.data); // pass your byte response to this constructor
          var blob_type = response.data.mimetype;
          var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download=response.data.original_name;
          link.click();
        }

      });
    } catch(error){
      commit('getProjectOnGoingList', []);
    }
  },
  addMilestone: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_milestone`,payload).then(response => {

        dispatch('getProjectContractorList');
      });
    } catch(error){
      commit('getProjectContractorList', []);
    }
  },
  addOrUpdateContractor: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/project_contractor`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        //message.mutations.setConfirmationAdd(message.state, true);
        dispatch('getProjectContractorList');
      });
    } catch(error){
      //message.mutations.setErrorMessage(message.state, true);
      commit('getProjectContractorList', []);
    }
  },
  getProjectFundingSourceList: ({ state, commit }, payload) => {
    try{
        axios.post(`/api/project_funding_source`,payload).then(response => {

          //console.log('funding_source: ', response.data);

        commit('setProjectFundingSourceList', response.data);
      });
    } catch(error){
      commit('setProjectFundingSourceList', []);
    }
  },
  deleteProject: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload,
        username : auth.state.username
      }

      //axios.post(`/api/delete_project`,{id: payload}).then(response => {
      axios.post(`/api/delete_project`,request).then(response => {
        message.mutations.setConfirmationDelete(message.state, true);
        dispatch('getProjectListApplication');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectListApplication', []);
    }
  },
  deleteExpense: ({ state, commit, dispatch }, payload) => {

    try{

      var request = {
        id: payload.id,
        username : auth.state.username
      }

      //axios.post(`/api/delete_expense`,{id: payload.id}).then(response => {
      axios.post(`/api/delete_expense`,request).then(response => {

        message.mutations.setConfirmationDelete(message.state, true);
        //dispatch('getProjectCompletedList');
        dispatch('checkIfProjectCompleted',{id: payload.project_id});

        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  deleteFund: ({ state, commit, dispatch }, payload) => {

    try{

      var request = {
        id: payload.id,
        username : auth.state.username
      }

      axios.post(`/api/delete_fund`,request).then(response => {

        message.mutations.setConfirmationDelete(message.state, true);
        dispatch('getProjectOnGoingList');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setProjectOnGoingList', []);
    }
  },
  deleteImg: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload.id,
        username : auth.state.username
      }

      //axios.post(`/api/delete_img`,{id: payload.id}).then(response => {
      axios.post(`/api/delete_img`,request).then(response => {

        //dispatch('getProjectApplicationPicture',{id: payload.project_id});
        //dispatch('getProjectReportingPicture',{id: payload.project_id});
        //dispatch('getProjectCompletionPicture',{id: payload.project_id});
        state.projectSelectedApplicationPicture = state.projectSelectedApplicationPicture.filter(img => img[0].id != request.id);
        state.projectSelectedReportingPicture = state.projectSelectedReportingPicture.filter(img => img[0].id != request.id);
        state.projectSelectedCompletionPicture = state.projectSelectedCompletionPicture.filter(img => img[0].id != request.id);

      });
    } catch(error){
      commit('setProjectOnGoingList', []);
    }
  }

}

const getters = {
  projectSelected: state => {
    return state.projectSelected
  },
  projectSelectedPlanPicture: state => {
    return state.projectSelectedPlanPicture
  },
  projectSelectedApplicationPicture: state => {
    return state.projectSelectedApplicationPicture
  },
  projectSelectedReportingPicture: state => {
    return state.projectSelectedReportingPicture
  },
  projectSelectedCompletionPicture: state => {
    return state.projectSelectedCompletionPicture
  },
  projectListApplication: state => {
    return state.projectListApplication
  },
  projectContractorList: state => {
    return state.projectContractorList
  },
  contractorProjectSelected: state => {
    return state.contractorProjectSelected
  },
  contractorList: state => {
    return state.contractorList
  },
  contractorDocuments: state => {
    return state.contractorDocuments
  },
  contractorProjectDocuments: state => {
    return state.contractorProjectDocuments
  },
  /*projectBudgetList: state => {
    return state.projectBudgetList
  },*/
  projectOnGoingList: state => {
    return state.projectOnGoingList
  },
  projectCompletedList: state => {
    return state.projectCompletedList
  },
  allProjectList: state => {
    return state.allProjectList
  },
  projectOwnerList: state => {
    return state.projectOwnerList
  },
  /*affectedAssetList: state => {
    return state.affectedAssetList
  },
  needList: state => {
    return state.needList
  },*/
  projectMilestoneList: state => {
    return state.projectMilestoneList
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
